import React from "react";
import Title from "../../components/TitleComponent";
import { Row, Col } from "react-bootstrap";
import { Image } from "react-bootstrap";
import Details from "../../components/DetailsComponent";
import EventWImage from "../../components/EventWImageComponent";
import Objectives from "../../components/ObjectivesComponent";
import { Helmet } from "react-helmet-async";

export default function Logopedy() {

  const intro1 = "Particularitatile de limbaj in TSA variaza de la absenta limbajului verbal pana la un limbaj aparent bine dezvoltat, dar cu dificultati in sfera comunicarii sociale, discurs despre interese limitate, un limbaj rigid, cu o prosodie atipica sau o topica diferita.";

  const intro2 = "In cazul copiilor nonverbali cu TSA, particularitatile de limbaj includ absenta vorbirii functionale sau folosirea unui numar foarte mic de cuvinte, insa, desi nu utilizeaza neaparat o vorbire articulata, de cele mai multe ori ei reusesc sa isi faca cunoscute nevoile prin vocalizari specifice sau anumite comportamente.";

  const nonverbalItems = [
    "Lipsa gesturilor sociale (nu ridica bratele pentru a fi luati in brate, nu bat palma dupa o reusita, nu fac cu mana cand parasesc o incapere desi au fost salutati astfel, nu se asaza pe scaunel daca cealalta persoana atinge usor si repetat scaunul, nu intinde mana pentru a da noroc etc.)",
    "Evitarea contactului vizual cu cei din jur.",
    "Lipsa gestului de a arata elemente pe care si le doresc si lipsa atentiei impartasite.",
    "Comportamente indezirabile (lovit, muscat - pe sine sau pe altii-, trantit la podea, tipat etc.) ca forma de protest, daca nu se pot face intelesi."

  ];

  const nonverbalItems2 = [

    "Folosirea vocalizarilor pe diferite tonalitati pentru a exprima placere, disconfort, frustrare sau pentru reglare emotionala.",
    "Folosirea adultului din proximitate pentru a realiza diferite actiuni, fara a realiza contact vizual cu acesta (ia mana adultului si o indrepta spre obiectul de interes, pentru ca acesta sa fie manevrat de catre adult).",
    "Lipsa intelegerii instructiunilor simple.",
    "Lipsa raspunsului de orice tip la strigarea pe nume."
  ];

  const higherFunctioningItems = [
    "In cazul ariilor de interes folosesc cu usurinta termeni tehnici pe care ceilalti de obicei nu ii cunosc.",
    "Tind sa vorbeasca mult despre subiectul preferat fara a tine cont de semnalele pe care le da interlocutorul.",
    "Tonalitatea vocii poate fi monotona sau foarte \"animata\".",
    "Uneori folosesc termeni in limba engleza mai degraba decat in limba romana sau tind sa vorbeasca mai degraba la persoana a II-a singulara decat la persoana I (mai ales la debutul limbajului verbal).",
    "Apar ecolalia imediata (mai ales in contextul in care nu stiu sa raspunda la o intrebare sau nu sunt atenti) si ecolalia intarziata (ca modalitate de exprimare a unei emotii pe care o asociaza cu o anumita exprimare verbala sau ca modalitate de reglare emotionala)."
  ];

   const higherFunctioningItems2 = [
    "Volumul vocii poate fi prea ridicat sau prea scazut pentru un anumit context.",
    "Deseori exprimarea poate fi atat de directa incat poate deranja pe celalalt (exemplu: \"Ce coc mare are doamna aceea!\" facand doar o remarca nevinovata, dar spus pe o tonalitate ridicata cealalta persoana se poate simti ofensata).",
    "Pot aparea dificultati in a intelege ironia, sarcasmul, metaforele.",
    "Contactul vizual poate fi uneori evitat alteori prea intens pentru cealalta persoana.",
    "De multe ori limbajul corpului nu este in concordanta cu limbajul vorbit (poate povesti despre ceva trist cu zambetul pe buze, pe o tonalitate ridicata, jovial)."
  ];

   const higherFunctioningItems3 = [
    "Pot aparea cuvinte parazitare in discurs (cuvinte fara sens folosite in contexte nepotrivite sau frecventa acestora sa fie mare).",
    "Tind sa observe mai degraba detaliile legate de context dintr-o imagine complexa decat actiunea, oamenii sau emotiile de pe fata acestora.",
    "Deseori vorbesc in afara contextului (mai ales atunci cand cerintele din mediu sunt o provocare pentru ei, cand le este greu sa isi mentina atentia in conversatie, cand sunt mai obositi etc.)",
    "Uneori adreseaza intrebari pentru a initia sau a mentine o conversatie, dar fara a realiza contact vizual cu cealalta persoana si fara a asteptata neaparat un raspuns din partea acesteia."
  ];

  const conclusion = "Pentru un copil sau un tanar cu TSA, oricare ar fi nivelul sau de dezvoltare, limbajul poate fi o adevarata provocare, de aceea ei au nevoie de sprijin, de oameni constienti care sa le fie alaturi cu rabdare si intelegere, care sa ii ghideze si sa le explice contexte, situatii de viata sau efectiv sa le arate sau sa le ofere formula verbala adecvata social pentru ca ei sa se poata face intelesi. Atunci cand se simt intelesi, creste stima de sine, descresc comportamentele considerate a fi indezirabile, sunt mai motivati sa comunice cu cei din jur si pot fi o reala resursa de inspiratie pentru oricine.";

  return (
    <>
      <Helmet>
        <title>Particularitatile de limbaj in tulburarea de spectru autist</title>
        <meta
          name="description"
          content="Particularitatile de limbaj in tulburarea de spectru autist - caracteristici ale limbajului la copiii nonverbali si cu nivel inalt-functional. Articol Asociatia PsiNapsis din Sibiu."
        />
        <link rel="canonical" href="https://www.psinapsis.ro/articles/logopedyarticle" />
      </Helmet>
      <Row className="p-0 m-0">
        <Col className="d-none d-xl-block"></Col>
        <Col className="whiteBg p-0 m-0 pb-5 min-xl-screen-size">
          <Title title="Particularitatile de limbaj in tulburarea de spectru autist" />
          <Details normalText={intro1} />
          <Details normalText={intro2} />
          
          <Details boldText="In cazul copiilor nonverbali cu TSA," />

          <EventWImage
            photoSource="/images/articol logopedie.jpeg"
            alt="Particularitatile de limbaj in tulburarea de spectru autist, Asociatia PsiNapsis Sibiu"
            objectives={nonverbalItems}
          />

          <Objectives
            talign="objective-align-justify"
            objectives={nonverbalItems2}
          />

          <Image
            className="photoArticol d-block d-md-none mb-3 mx-auto"
            src="/images/articol logopedie.jpeg"
            alt="Particularitatile de limbaj in tulburarea de spectru autist, Asociatia PsiNapsis Sibiu"
          />

          <Details boldText="In cazul copiilor cu TSA inalt-functionali " normalText=" limbajul verbal este fluent, vocabularul bogat, dar:" />

          <Objectives
            talign="objective-align-justify"
            objectives={higherFunctioningItems}
          />

          <EventWImage
            photoSource="/images/articol logopedie 2.jpeg"
            alt="Particularitatile de limbaj in tulburarea de spectru autist, Asociatia PsiNapsis Sibiu"
            objectives={higherFunctioningItems2}
          />

          <Objectives
            talign="objective-align-justify"
            objectives={higherFunctioningItems3}
          />

          <Image
            className="photoArticol d-block d-md-none mb-3 mx-auto"
            src="/images/articol logopedie 2.jpeg"
            alt="Particularitatile de limbaj in tulburarea de spectru autist, Asociatia PsiNapsis Sibiu"
          />

          <Details normalText={conclusion} />
        </Col>
        <Col className="d-none d-xl-block"></Col>
      </Row>
    </>
  );
}
